import validate from "D:/my-projects/vue-app/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import common_45global from "D:/my-projects/vue-app/nuxt-app/app/middleware/common.global.ts";
import manifest_45route_45rule from "D:/my-projects/vue-app/nuxt-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  common_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}